import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import * as Layout from './Layout';
import * as db from './db';
import { createMemoryHistory } from 'history';
export default function configureStore(history, initialState) {
    const isServer = !(  typeof window !== 'undefined' && window.document && window.document.createElement)
    
    const reducers = {
        layout: Layout.reducer,
        db: db.reducer
    };
    history = isServer ? createMemoryHistory({initialEntries: [initialState.history]}) : history;
    const middleware = [
        thunk,
        routerMiddleware(history)
    ];
    
    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        router: connectRouter(history)
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}
